import { useCurrentUser } from 'hooks/api/use-current-user';
import { useImpersonation } from 'hooks/use-impersonation';

import { ROLES } from 'constants/roles';

export const useMarkReadOnly = (): boolean => {
  const { data: currentUser } = useCurrentUser();
  const { isImpersonating } = useImpersonation();

  return Boolean(isImpersonating()) && currentUser?.authority === ROLES.USER;
};
